<template>
  <div class="tip-container">
    <div
      v-if="type === 'text'"
      class="tip-info"
    >
      <span class="tip-content">{{ msg }}</span>
    </div>
    <div
      v-else
      class="content-container"
    >
      <img
        v-if="type === 'success'"
        src="https://s3.meituan.net/static-prod01/com.sankuai.fspfepayresource.front.settings-files/toast-success-icon.png"
        class="icon"
      />
      <img
        v-else-if="type === 'error'"
        src="https://s3.meituan.net/static-prod01/com.sankuai.fspfepayresource.front.settings-files/toast-fail-icon.png"
        class="icon"
      />
      <div class="text">
        {{ msg }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Tip',
  props: {
    type: {
      type: String,
      default: 'text'
    },
    msg: {
      type: String,
      default: ''
    },
  }
};
</script>
<style lang="less" scoped>
.tip-container {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;

  .tip-info {
    position: absolute;
    top: 55%;
    right: 0;
    left: 0;
    text-align: center;
    span {
      display: inline-block;
      border-radius: .12rem;
      margin: 0 auto;
      background: rgba(0, 0, 0, 0.8);
      padding: .36rem;
      font-size: .28rem;
      min-width: 2.6rem;
      max-width: 3.5rem;
      color: #fff;
    }
  }

  .content-container {
    padding: .38rem .1rem .34rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    width: 2.6rem;
    background: rgba(26, 26, 26, 0.9);
    border-radius: .16rem;
    .icon {
      width: .7rem;
      height: .7rem;
    }
    .text {
      font-size: .28rem;
      line-height: .32rem;
      text-align: center;
      overflow: hidden;
      color: #ffffff;
    }
  }
}
</style>
